// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-wrapper>div{margin-top:0}\n", "",{"version":3,"sources":["webpack://./frontend/src/pages/instance/Assets.vue"],"names":[],"mappings":"AAEA,oBACE,YAAa","sourcesContent":["@import \"@/ui-components/stylesheets/ff-colors.scss\";@import \"@/ui-components/stylesheets/ff-utility.scss\";\n\n.banner-wrapper > div {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
